module.exports = __webpack_public_path__ + "img/sounds-off.439e0d70.jpg";